import ReactGA from "react-ga4";

const useAnalyticsEventTracker = (category = "Test category") => {
    const eventTracker = (action = "Test action", label = "Test label") => {
        ReactGA.event({ category, action, label });
    };
    return eventTracker;
};
export default useAnalyticsEventTracker;
